module.exports = __webpack_public_path__ + "static/2-9f7131ce4a5d61ba45a56aacd67742da.jpeg";